













	import Vue from "vue";

	export default Vue.extend({
		props: ['order'],
		methods: {
			show() {
				let $comment = $('#show_comment_' + this.order.id);
                if($comment.find('.comment-modal').is(':visible')) {
                    $comment.find('.comment-modal').fadeOut(300);
                    return false;
                }
                $('.comment-modal').fadeOut(300);
                $('.oc-table').find('tr').removeClass('hover');
                $comment.find('.comment-modal').fadeIn(300);
                $comment.closest('tr').addClass('hover');
                return false;
			}
		}
	})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/backend/components/table/fields/CommentField.vue